import { useTranslation } from "react-i18next";

const StatsBanner = ({ title }) => {
  const { t } = useTranslation();

  const stats = [
    {
      title: t("80k+"),
      description: t("PDFs added per month"),
    },
    {
      title: t("43k%"),
      description: t("PDFs Protected per month"),
    },
    {
      title: t("2M"),
      description: t("PDFs edited per month"),
    },
    {
      title: t("140k+"),
      description: t("PDFs downloaded per month"),
    },
  ];
  return (
    <section className="bg-primary-400 py-16 lg:py-28">
      <div className="container flex flex-col justify-center items-center text-center">
        <h2 className="text-secondary-1000 max-w-[52.625rem]">{title}</h2>
        <ul className="container !max-w-6xl mx-auto flex-wrap gap-8 sm:gap-0 sm:flex-nowrap flex justify-center sm:justify-between w-full md:mt-16 mt-10">
          {stats.map((stat, i) => (
            <li key={i}>
              <h3 className="xl:text-7xl text-5xl font-bold">{stat.title}</h3>
              <p>{stat.description}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
export default StatsBanner;
